// extracted by mini-css-extract-plugin
export var spaces_header = "studySpacesListHeader-module--spaces_header--5e4a2";